import React, { FC } from "react";
import { Svg } from "@natera/material/lib/svg";
import ThumbsUpIcon from "@assets/svg/icons/thums-up.svg";

import "./thankYouCard.scss";

interface ThankYouCardProps {
  title: string;
  message: React.ReactNode;
}

const ThankYouCard: FC<ThankYouCardProps> = ({ title, message }) => {
  return (
    <div className="thank-you-card">
      <div className="thank-you-card__icon" aria-hidden>
        <Svg content={ThumbsUpIcon} />
      </div>
      <h1 className="thank-you-card__title">{title}</h1>
      <p className="thank-you-card__message">{message}</p>
    </div>
  );
};

export default ThankYouCard;
